export const carriersTags = [
  'carriers_modifyAdd',
  'carriers_imageUpdate',
  'carriers_documentDeleteUpdate',
  'carriers_bookingModifyAdd',
  'carriers_addSeller',
  'get_master_make',
  'get_master_auction_house',
  'master_sellers',
  'master_dealers',
] as const;
